import { computeBoundsTree, MeshBVH, MeshBVHVisualizer } from "three-mesh-bvh";
import { drawLine, drawPoint } from "../draw/draw";
import { Apps, getGlobalCenter } from "./DicomManager";
import Konva from "konva";
import { gingivae } from "../intraoral/IntraoralManager";

//#region Fields
const params = {
  useBVH: true,
  helperDepth: 5,
};

// let colliderBvh, colliderMesh, bvhHelper;
// const zeroPoint = { x: 0, y: 0 };
let ctxTransformed = false;

const tempVector = new THREE.Vector3();
const tempLine = new THREE.Line3();
const localPlane = new THREE.Plane();
const clippingPlane = new THREE.Plane();
const outlineShapeName = "outlineShape";

let currentModel = null;

//#endregion

function destroyOutlines(app) {
  const layerGroup = app.getActiveLayerGroup();
  const drawLayer = layerGroup.getActiveDrawLayer();
  if (drawLayer) {
    let konvaLayer = drawLayer.getKonvaLayer();
    let stage = konvaLayer.getStage();
    if (stage.outlineLayer) {
      let outlineShapes = stage.outlineLayer.find("." + outlineShapeName);
      outlineShapes.forEach((shape) => {
        shape.destroy();
      });
    }
  }
  app.outlineSplines = {};
}

function switchOutlineListening(app, listening) {
  try {
    const layerGroup = app.getActiveLayerGroup();
    const drawLayer = layerGroup.getActiveDrawLayer();
    if (drawLayer) {
      let konvaLayer = drawLayer.getKonvaLayer();
      let stage = konvaLayer.getStage();
      if (stage.outlineLayer) {
        let outlineShapes = stage.outlineLayer.find("." + outlineShapeName);
        outlineShapes.forEach((shape) => {
          shape.listening(listening);
        });
      }
    }
  } catch (error) {
    console.error("switchOutlineListening", error);
  }
}

function drawOutlines(app, dicomBox, sliceIndex, isCalculating, force) {
  if (app && dicomBox) {
    destroyOutlines(app);
    // console.log("drawOutlines", app.divId);
    if (app.isCeph) {
      return;
    }

    const canvas = $(`#${app.divId}-layer-0 canvas`)[0];
    const canvasContext = canvas.getContext("2d");
    if (app.noBackground) {
      canvasContext.fillStyle = "black";
      // ctx.fillStyle = "#000000"; // Alternative using hex code
      canvasContext.fillRect(0, 0, canvas.width, canvas.height);
    }

    if (!app.segmentations) {
      app.segmentations = [];
      return;
    }

    if (!app.showSegmentation) {
      return;
    }

    ctxTransformed = false;

    let dy = app.index != 0 ? app.worldSize.y - dicomBox.size.y : 0;
    // need fix: 5883551701953156148, 5596721689254332792
    // let currentTransform = canvasContext.getTransform();
    // let cy = Math.abs(currentTransform.a / currentTransform.d);
    // if (currentTransform.f != 0) {
    // }
    let drawingBox = getDrawBox2D(dicomBox, app);
    // console.log("drawingBox", drawingBox);
    if (!sliceIndex) sliceIndex = app.current;
    setupClippingPlane(app, dicomBox, sliceIndex);
    let sliceConstant = clippingPlane.constant;

    let items = getSegmentItems(app, isCalculating);

    const layerGroup = app.getActiveLayerGroup();
    const drawLayer = layerGroup.getActiveDrawLayer();
    // const drawDiv = drawLayer.getContainerDiv();
    // if (drawDiv) {
    //   drawDiv.style.pointerEvents = "auto";
    // }

    let konvaLayer = drawLayer ? drawLayer.getKonvaLayer() : null;
    let stage = konvaLayer ? konvaLayer.getStage() : null;
    if (stage) {
      // if (stage.outlineLayer) {
      //   stage.outlineLayer.destroy();
      //   stage.outlineLayer = undefined;
      // }

      if (!stage.outlineLayer) {
        stage.outlineLayer = new Konva.Layer();
        let canvas = stage.outlineLayer.getCanvas();
        canvas._canvas.setAttribute("id", `${app.divId}-outline-layer`);
        // console.log("outline-layer canvas", canvas._canvas);
        stage.add(stage.outlineLayer);
        // var container = document.querySelector(`#${app.divId}-layer-0`);
        // console.log("outline-layer 1", container);
        // var div = document.createElement("div");
        // div.setAttribute("id", `${app.divId}-outline-container`);
        // div.style.width = "100%";
        // div.style.height = "100%";
        // div.style.position = "absolute";
        // container.appendChild(div);

        // var stage = new Konva.Stage({
        //   container: `${app.divId}-outline-container`,
        //   width: container.offsetWidth,
        //   height: container.offsetHeight,
        // });

        // viewerLayer.outlineLayer = new Konva.Layer();
        // drawLayer.bindInteraction();
      }
      konvaLayer = stage.outlineLayer;
    }

    let konvaDrawed = false;
    items.forEach((model, index) => {
      if (model.isHidden || !model.isVisible) return;
      // if (model.isAdded) {
      //   console.log("isAdded", model);
      // }

      // if (app.demo && index != 0) return; // index != 6 !model.isTooth
      let figures = getFiguresForModel(
        model,
        clippingPlane,
        app,
        sliceIndex,
        force,
        dy,
        true,
      );
      if (!isCalculating && figures && figures.length) {
        // console.log(model.filename, figures);
        model.actualColor = getActualColor(
          app,
          canvasContext,
          model,
          sliceConstant,
          drawingBox,
        );

        if (model.isTooth && !konvaDrawed) {
          // konvaDrawed = true;
          drawOnKonvaLayer(figures, konvaLayer, app, model, drawingBox);
        } else {
          drawOn2DCanvas(figures, canvasContext, app, model, drawingBox);
        }
      }
    });
    // drawLayer.bindInteraction();
    if (stage) {
      stage.listening(true);
      stage.batchDraw();
    }
    if (konvaLayer) {
      konvaLayer.listening(true);
      konvaLayer.draw();
      konvaLayer.drawHit();
    }

    // console.log("isListening", stage.isListening(), konvaLayer.isListening());
  }
}

function getActualColor(app, ctx, model, sliceConstant, drawingBox) {
  let actualColor = vueApp.getActualColor(model);
  if (model.colors && model.boundingBox) {
    if (app.index == 0) {
      let boundingBox = model.boundingBox;
      model.colors.forEach((colorObj) => {
        let constY =
          boundingBox.min.y + (colorObj.stop - 0.05) * boundingBox.size.y;
        if (constY <= sliceConstant) {
          actualColor = colorObj.color;
        }
      });
    } else {
      let sizeHeight = app.baseSize ? app.baseSize.y : ctx.canvas.clientHeight;
      let coefY = sizeHeight / drawingBox.size.y;

      let boundingBox = model.boundingBox;
      const gradient = ctx.createLinearGradient(
        0,
        boundingBox.min.y * coefY,
        0,
        boundingBox.max.y * coefY,
      );
      model.colors.forEach((colorObj) => {
        gradient.addColorStop(colorObj.stop, colorObj.color);
      });
      // gradient.addColorStop(0.5, "green");
      // gradient.addColorStop(1, "blue");
      actualColor = gradient;
    }
  }
  return actualColor;
}

function getSegmentItems(app, isCalculating) {
  let items = [];
  let teeth = vueApp.allTeeth;
  let bones = vueApp.bones;
  let airways = vueApp.airways;
  let nerves = vueApp.nerves;
  let gingivae = vueApp.gingivae;

  // items.push(gingivae.find(g => g.isUpper));
  // return items;

  if (app.segmentations.includes("maxTeeth") || isCalculating) {
    items = items.concat(
      teeth.filter(
        (item) => item.isMaxilla && item.isVisible && !item.isHidden,
      ),
    );
  }
  if (app.segmentations.includes("mandTeeth") || isCalculating) {
    items = items.concat(
      teeth.filter(
        (item) => !item.isMaxilla && item.isVisible && !item.isHidden,
      ),
    );
  }
  if (app.segmentations.includes("maxilla") || isCalculating) {
    items = items.concat(
      bones.filter(
        (item) => item.name == "Maxilla" && item.isVisible && !item.isHidden,
      ),
    );
  }
  if (app.segmentations.includes("mandible") || isCalculating) {
    items = items.concat(
      bones.filter(
        (item) => item.name != "Maxilla" && item.isVisible && !item.isHidden,
      ),
    );
  }
  if (app.segmentations.includes("airway") || isCalculating) {
    items = items.concat(
      airways.filter((item) => item.isVisible && !item.isHidden),
    );
  }
  if (app.segmentations.includes("nerve") || isCalculating) {
    items = items.concat(
      nerves.filter((item) => item.isVisible && !item.isHidden),
    );
  }

  if (app.segmentations.includes("gingiva") || isCalculating) {
    items = items.concat(
      gingivae.filter((item) => item.isVisible && !item.isHidden),
    );
  }
  return items;
}

function getDrawBox2D(dicomBox, app) {
  let drawingBox = {};
  drawingBox.min = convertTo2dPoint(dicomBox.min.clone(), app.index);
  drawingBox.max = convertTo2dPoint(dicomBox.max.clone(), app.index);
  drawingBox.center = convertTo2dPoint(dicomBox.center.clone(), app.index);
  drawingBox.size = convertTo2dPoint(dicomBox.size.clone(), app.index);
  // drawingBox.min = convertTo2dPointFromApp(dicomBox.min.clone(), app);
  // drawingBox.max = convertTo2dPointFromApp(dicomBox.max.clone(), app);
  // drawingBox.center = convertTo2dPointFromApp(dicomBox.center.clone(), app);
  // drawingBox.size = convertTo2dPointFromApp(dicomBox.size.clone(), app);
  return drawingBox;
}

function setupClippingPlane(app, dicomBox, sliceIndex) {
  const layerGroup = app.getLayerGroupByDivId(app.divId);
  const viewLayer = layerGroup.getActiveViewLayer();
  let matrix4 = viewLayer.matrix4;

  if (!sliceIndex) sliceIndex = +app.current;
  let constant = 0;
  let offset = (sliceIndex - 1) / app.max; //(app.max - 1);
  if (app.index == 0) {
    clippingPlane.normal.set(0, -1, 0);
    constant = dicomBox.min.y + dicomBox.size.y * offset;
  }
  if (app.index == 1) {
    clippingPlane.normal.set(-1, 0, 0);
    constant = dicomBox.min.x + dicomBox.size.x * offset;
  }
  if (app.index == 2) {
    offset = (app.max - sliceIndex + 1) / app.max;
    clippingPlane.normal.set(0, 0, -1);
    constant = dicomBox.min.z + dicomBox.size.z * offset;
  }
  clippingPlane.constant = constant;

  if (matrix4) {
    // && app.index == 0) {
    // TODO: get pivotPoint
    const pivotPoint = getGlobalCenter();
    // new THREE.Vector3(
    //   dicomBox.center.x,
    //   dicomBox.center.y,
    //   dicomBox.center.z,
    // );

    // const pivotPoint = clippingPlane.normal
    //   .clone()
    //   .multiplyScalar(-clippingPlane.constant);

    transformPlaneAroundPoint(clippingPlane, matrix4, pivotPoint);
    app.pointMatrix = getMatrixAroundPoint(matrix4, pivotPoint);

    app.inversePointMatrix = app.pointMatrix.clone().invert();
    // console.log("setupClippingPlane", app.pointMatrix);
    // if (app.visualPlane3) {
    //   viewer.scene.remove(app.visualPlane3);
    // }
    // app.visualPlane3 = createVisualPlaneFromMathPlane(clippingPlane, 92);
    // viewer.scene.add(app.visualPlane3);
  }
  return clippingPlane;
}

function getMatrixAroundPoint(matrix, pivot) {
  // Create a transformation matrix that includes the pivot translation
  const tempMatrix = new THREE.Matrix4();

  // Compose: translate to origin -> transform -> translate back
  tempMatrix.makeTranslation(-pivot.x, -pivot.y, -pivot.z);
  tempMatrix.premultiply(matrix); // premultiply multiply
  tempMatrix.premultiply(
    new THREE.Matrix4().makeTranslation(pivot.x, pivot.y, pivot.z),
  );

  return tempMatrix;
}

function transformPlaneAroundPoint(plane, matrix, pivotPoint) {
  const tempPlane = plane.clone();

  // Move plane to pivot point space
  const translationToPivot = new THREE.Vector3().subVectors(
    tempPlane.normal.clone().multiplyScalar(-tempPlane.constant),
    pivotPoint,
  );

  // Transform the normal
  tempPlane.normal.applyMatrix4(matrix).normalize();

  // Transform a point on the plane and calculate new constant
  const transformedPoint = pivotPoint
    .clone()
    .add(translationToPivot.applyMatrix4(matrix));

  tempPlane.constant = -transformedPoint.dot(tempPlane.normal);
  plane.copy(tempPlane);
  return plane;
}

function createVisualPlaneFromMathPlane(plane, size = 10, color = 0xff0000) {
  const geometry = new THREE.PlaneGeometry(size, size);
  const material = new THREE.MeshBasicMaterial({
    color: color,
    side: THREE.DoubleSide,
    transparent: true,
    opacity: 0.7,
  });

  const mesh = new THREE.Mesh(geometry, material);

  // Calculate position (point on the plane)
  const position = plane.normal.clone().multiplyScalar(-plane.constant);
  mesh.position.copy(position);

  // Align the mesh to face the plane's normal direction
  const target = position.clone().add(plane.normal);
  mesh.lookAt(target);

  return mesh;
}

function getFiguresForModel(
  model,
  clippingPlane,
  app,
  sliceIndex,
  force,
  dy,
  excludeInner,
) {
  let figures = null;
  if (model && model.filename) {
    // let modelSegmentation = dicomSegmentation[model.filename];
    // if (!modelSegmentation) {
    //   modelSegmentation = {};
    //   dicomSegmentation[model.filename] = modelSegmentation;
    // }
    // let segmentationKey = `${app.orientation}_${sliceIndex}`;
    // figures = modelSegmentation[segmentationKey];
    // if (!app.isAnnotating) {
    //   figures = null;
    // } else if (!model.isTooth && !force) {
    //   figures = [];
    // }

    // TODO: optimize for non rotated
    if (!figures || model.needUpdateDicom || force) {
      let mesh = viewer.get_model_mesh(model.id);
      if (mesh && mesh.type == "Mesh" && mesh.geometry) {
        // && mesh.visible
        let segments = getMeshSegmentsForPlane(mesh, clippingPlane, app);
        if (dy) {
          segments.forEach((segment) => {
            segment.p1.y -= dy;
            segment.p2.y -= dy;
          });
        }
        let verticesArr = [];
        while (segments.length > 0) {
          let vertices = getVerticesFromSegments(segments);
          if (vertices.length) {
            verticesArr.push(vertices);
          }
        }
        figures = getFiguresFromVertices(verticesArr, model);

        if (
          excludeInner &&
          (model.isTooth || model.isNerve) &&
          figures.length > 1
        ) {
          let largeFigure = figures[0];
          let smallFigures = figures.slice(1);
          smallFigures.forEach((small) => {
            if (isFigureInside(small, largeFigure)) {
              let innerIndex = figures.indexOf(small);
              figures.splice(innerIndex, 1);
            }
          });
        }

        // modelSegmentation[segmentationKey] = figures;
      }
    }
  }
  return figures;
}

function isFigureInside(small, large) {
  // figure = { vertices: vertices, filename: model.filename }
  for (const vertex of small.vertices) {
    if (!isPointInside(vertex, large.vertices)) {
      return false;
    }
  }
  return true;
}

function isPointInside(point, vs) {
  // ray-casting algorithm based on
  // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html
  var x = point.x,
    y = point.y;

  var inside = false;
  for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
    var xi = vs[i].x,
      yi = vs[i].y;
    var xj = vs[j].x,
      yj = vs[j].y;

    var intersect =
      yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }

  return inside;
}

function getAllFiguresForModel(model, app, dicomBox, excludeInner, force) {
  let allFigures = {};
  if (model && app) {
    let dy = app.index != 0 ? app.worldSize.y - dicomBox.size.y : 0;
    let mesh = viewer.get_model_mesh(model.id);
    let sliceIndexes = getSliceIndexes(mesh, app, dicomBox);
    for (const sliceIndex of sliceIndexes) {
      setupClippingPlane(app, dicomBox, sliceIndex);
      let tempFigures = getFiguresForModel(
        model,
        clippingPlane,
        app,
        sliceIndex,
        force,
        dy,
        excludeInner,
      );
      if (tempFigures && tempFigures.length) {
        allFigures[+sliceIndex] = tempFigures;
      }
    }
  }
  return allFigures;
}

function getSliceIndexes(mesh, app, dicomBox) {
  let indexes = [];
  let meshGeometry = mesh ? mesh.geometry : null;
  if (meshGeometry) {
    // mesh.baseGeometry ? mesh.baseGeometry : mesh.geometry;
    let geometry = meshGeometry.clone();
    geometry.applyMatrix4(mesh.matrix);
    let toothBox = geometry.boundingBox;
    for (let i = 1; i <= app.max; i++) {
      let constant = 0;
      let offset = (i - 1) / app.max; //(app.max - 1);
      if (app.index == 0) {
        constant = dicomBox.min.y + dicomBox.size.y * offset;
        if (constant >= toothBox.min.y && constant <= toothBox.max.y)
          indexes.push(i);
      }
      if (app.index == 1) {
        constant = dicomBox.min.x + dicomBox.size.x * offset;
        if (constant >= toothBox.min.x && constant <= toothBox.max.x)
          indexes.push(i);
      }
      if (app.index == 2) {
        offset = (app.max - i + 1) / app.max; //(app.max - 1);
        constant = dicomBox.min.z + dicomBox.size.z * offset;
        if (constant >= toothBox.min.z && constant <= toothBox.max.z)
          indexes.push(i);
      }
    }
  }
  return indexes;
}

function drawOn2DCanvas(figures, ctx, app, model, drawingBox) {
  // console.log("drawOn2DCanvas", model.filename);
  if (!figures || !figures.length || !ctx) {
    return;
  }

  let appIndex = app.index;
  let color = model ? model.actualColor : app.color;
  ctx.strokeStyle = color;
  ctx.fillStyle = color;
  ctx.lineWidth = app.outlineThickness;
  ctx.globalAlpha = app.opacity; //0.5;

  // TO OPTIMIZE
  let sizeWidth = app.baseSize ? app.baseSize.x : ctx.canvas.clientWidth;
  let sizeHeight = app.baseSize ? app.baseSize.y : ctx.canvas.clientHeight;
  // let coef = appIndex == 0 ? sizeWidth / drawingBox.size.x : sizeHeight / drawingBox.size.y;
  let coefX = sizeWidth / drawingBox.size.x;
  let coefY = sizeHeight / drawingBox.size.y;

  if (!ctxTransformed) {
    ctxTransformed = true;
    if (appIndex == 0) {
      ctx.translate(
        -drawingBox.min.x * coefX,
        -drawingBox.min.y * coefY + drawingBox.center.y * coefY * 2,
      );
      ctx.rotate(Math.PI);
      ctx.scale(-1, 1);
    }
    if (appIndex == 1) {
      ctx.translate(
        -drawingBox.min.x * coefX + drawingBox.center.x * coefX * 2,
        -drawingBox.min.y * coefY,
      );
      ctx.scale(-1, 1);
    }
    if (appIndex == 2) {
      ctx.translate(-drawingBox.min.x * coefX, -drawingBox.min.y * coefY);
    }
  }

  ctx.beginPath();

  figures.forEach((figure) => {
    figure.vertices.forEach((p, index) => {
      let x1 = p.x * coefX;
      let y1 = p.y * coefY;
      if (index == 0) {
        ctx.moveTo(x1, y1);
      } else {
        ctx.lineTo(x1, y1);
      }
    });
    if (model && model.isTooth) {
      ctx.closePath();
    }
  });
  // ctx.mozFillRule = 'evenodd';
  ctx.stroke();
  if (
    !model ||
    (app.segmentationType === "fillAll" && !model.isGingiva) ||
    (model.isTooth && app.segmentationType === "fillTeeth")
  ) {
    ctx.fill("evenodd");
  }
}

function setOutlinePoints(figure, app, drawBox, coefX, coefY) {
  if (figure && !figure.outlinePoints) {
    figure.outlinePoints = [];
    if (!coefX) coefX = app.baseSize.x / drawBox.size.x;
    if (!coefY) coefY = app.baseSize.x / drawBox.size.x;
    figure.vertices.forEach((p, index) => {
      let kp = convertToKonvaPoint(p, coefX, coefY, drawBox, app.index);
      figure.outlinePoints.push(kp);
    });
  }
}

function convertToKonvaPoint(p, coefX, coefY, drawBox, appIndex) {
  if (drawBox) {
    let newX = appIndex == 1 ? drawBox.max.x - p.x : p.x - drawBox.min.x;
    let newY = appIndex == 0 ? drawBox.max.y - p.y : p.y - drawBox.min.y;
    //-p.y - drawBox.min.y;

    let point = {
      x: newX * coefX,
      y: newY * coefY,
    };
    return point;
  }
}

function drawOnKonvaLayer(figures, konvaLayer, app, model, drawingBox) {
  if (!figures || !konvaLayer || !figures.length) {
    return;
  }
  let appIndex = app.index;
  let color = model ? model.actualColor : app.color;

  const coefX = app.baseSize.x / drawingBox.size.x;
  const coefY = app.baseSize.y / drawingBox.size.y;

  let fillEnabled =
    app.segmentationType === "fillAll" ||
    (model.isTooth && app.segmentationType === "fillTeeth");
  model.fillEnabled = fillEnabled;

  app.outlineSplines[model.filename] = [];
  figures.forEach((figure) => {
    if (!figure.outlinePoints)
      setOutlinePoints(figure, app, drawingBox, coefX, coefY);

    figure.color = color;
    // figure.model = model;
    // figure.app = app;
    let spline = drawSpline(konvaLayer, figure, app, model, fillEnabled);
    app.outlineSplines[model.filename].push(spline);
    //figure.spline.getChildren()[0].fillEnabled(false);
  });
  // let stage = konvaLayer.getStage();
  // console.log(stage);
  // var shape = new Konva.Rect({
  //   name: outlineShapeName,
  //   x: 0,
  //   y: 0,
  //   opacity: 0.5,
  //   width: 100,
  //   height: 100,
  //   fill: "blue",
  //   stroke: "black",
  //   listening: true,
  //   strokeWidth: 1,
  // });
  // shape.on("mouseenter", (e) => {
  //   console.log("mouseenter");
  //   e.target.opacity(1);
  // });
  // shape.on("mouseleave", (e) => {
  //   console.log("mouseleave");
  //   e.target.opacity(0.5);
  // });
  // konvaLayer.add(shape);
  // konvaLayer.draw();
}

function drawSpline(konvaLayer, figure, app, shapeModel, fillEnabled) {
  if (figure.outlinePoints < 3) return;

  // let app = figure.app;
  // let model = figure.model;
  let color = figure.color;
  let mainShape = new Konva.Shape({
    name: outlineShapeName,
    figure: figure,
    model: shapeModel,
    // visible : 'inherit',
    stroke: color, //hexToCanvasColor(color, app.opacity),
    fill: color, //hexToCanvasColor(color, app.opacity),
    strokeWidth: app.outlineThickness,
    strokeEnabled: true,
    opacity: app.opacity,
    fillEnabled: fillEnabled,
    listening: true,
    sceneFunc: (ctx, shape) => {
      // const currentScale = konvaLayer.getStage().scale().x;
      // console.log("!!! sceneFunc", currentScale);
      // const newStrokeWidth = Math.min(2, maxStrokeWidth / currentScale);
      // shape.strokeWidth(newStrokeWidth);

      let points = figure.outlinePoints;
      let n = points.length;
      let p0 = points[0];

      ctx.beginPath();
      ctx.moveTo(p0.x, p0.y);
      for (let i = 1; i < n; i++) {
        let p1 = points[i];
        ctx.lineTo(p1.x, p1.y);
      }

      ctx.closePath();
      ctx.fillStrokeShape(shape);
    },
  });

  mainShape.on("mouseenter", (e) => {
    // console.log("mouseenter");
    let model = e.target.attrs.model;
    if (model) model.isHovered = true;
    e.target.opacity(1);
    e.target.fillEnabled(true);
  });
  mainShape.on("mouseleave", (e) => {
    // console.log("mouseleave");
    let model = e.target.attrs.model;
    if (model) {
      model.isHovered = false;
      e.target.fillEnabled(model.fillEnabled);
    }
    if (app) e.target.opacity(app.opacity);
  });

  // const group = new Konva.Group({
  //   name: outlineShapeName,
  //   figure: figure,
  // });
  // group.add(mainShape); // , fillShape, borderShape
  // konvaLayer.add(group);
  // group.on("dblclick dbltap", (e) => {
  //   console.log("dblclick dbltap");
  // });
  konvaLayer.add(mainShape); // , fillShape, borderShape
  return mainShape;
}

function highlightOutlines(newModel) {
  if (newModel != currentModel) {
    // console.log("highlightOutlines", newModel ? newModel.filename : newModel);
    let apps = Apps;
    let filename = newModel ? newModel.filename : null;
    // console.log("highlightOutlines", filename);
    if (currentModel) {
      apps.forEach((app) => {
        if (
          app.visible &&
          app.outlineSplines &&
          currentModel.filename in app.outlineSplines
        ) {
          // vueApp.allTeeth.forEach((model) => {});
          app.outlineSplines[currentModel.filename].forEach((spline) => {
            spline.opacity(app.opacity);
            spline.fillEnabled(currentModel.fillEnabled);
          });
        }
      });
    }
    if (newModel) {
      apps.forEach((app) => {
        //  console.log(app.orientation, app.opacity, Object.keys(app.outlineSplines));
        if (
          app.visible &&
          app.outlineSplines &&
          filename in app.outlineSplines
        ) {
          app.outlineSplines[filename].forEach((spline) => {
            spline.opacity(1);
            spline.fillEnabled(true);
          });
        }
      });
    }
    currentModel = newModel;
  }
}

// https://github.com/gkjohnson/three-mesh-bvh/blob/master/README.md#constructor
function getMeshSegmentsForPlane(mesh, clippingPlane, app) {
  let segments = [];
  try {
    let meshGeometry = mesh.geometry;
    if (!meshGeometry.colliderBvh) {
      let bufferGeometry = null;
      if (meshGeometry._bufferGeometry)
        bufferGeometry = meshGeometry._bufferGeometry;
      else if (meshGeometry.type == "BufferGeometry") {
        bufferGeometry = meshGeometry;
      } else {
        try {
          bufferGeometry = new THREE.BufferGeometry().fromGeometry(
            meshGeometry,
          );
        } catch (error) {
          bufferGeometry = meshGeometry;
        }
      }
      const clonedGeometry = bufferGeometry.clone();
      clonedGeometry.applyMatrix4(mesh.matrixWorld);
      for (const key in clonedGeometry.attributes) {
        if (key === "position" || key === "normal") {
          continue;
        }
        clonedGeometry.deleteAttribute(key);
      }

      const colliderBvh = (mesh.colliderBvh = new MeshBVH(clonedGeometry, {
        maxLeaafTris: 20, // 10
        maxDepth: 30, // 40 //5
      }));
      meshGeometry.colliderBvh = colliderBvh;
      bufferGeometry.boundsTree = colliderBvh;
      const colliderMesh = new THREE.Mesh(bufferGeometry);
      colliderMesh.renderOrder = 2;
      const inverseMatrix = new THREE.Matrix4();
      inverseMatrix.copy(colliderMesh.matrixWorld).invert();
      meshGeometry.inverseMatrix = inverseMatrix;
    }
    segments = renderBVH(
      meshGeometry.colliderBvh,
      meshGeometry.inverseMatrix,
      clippingPlane,
      app,
    );
  } catch (error) {
    console.log("getMeshSegmentsForPlane error", error);
  }
  return segments;
}

function renderBVH(colliderBvh, inverseMatrix, clippingPlane, app) {
  // console.log("renderBVH", app.index, app.pointMatrix);
  let segments = [];
  if (colliderBvh) {
    // const startTime = window.performance.now();
    localPlane.copy(clippingPlane).applyMatrix4(inverseMatrix);
    let i = 0;
    colliderBvh.shapecast({
      intersectsBounds: (box) => {
        //return CONTAINED;
        return localPlane.intersectsBox(box);
      },
      intersectsTriangle: (tri) => {
        i++;
        // if (i > 27) {
        //   return;
        // }
        // let color = 0xff0000;
        // if (i % 2 == 0) color = 0x00ff00;
        // if (i % 3 == 0) color = 0x0000ff;
        // drawLine(tri.a, tri.b, color);
        // drawLine(tri.b, tri.c, color);
        // drawLine(tri.c, tri.a, color);
        // const vectors = [];
        const points = [];
        tempLine.start.copy(tri.a);
        tempLine.end.copy(tri.b);
        if (localPlane.intersectLine(tempLine, tempVector)) {
          // vectors.push(tempVector.clone());
          points.push(convertTo2dPointFromApp(tempVector, app));
        }

        tempLine.start.copy(tri.b);
        tempLine.end.copy(tri.c);
        if (localPlane.intersectLine(tempLine, tempVector)) {
          // vectors.push(tempVector.clone());
          points.push(convertTo2dPointFromApp(tempVector, app));
        }

        tempLine.start.copy(tri.c);
        tempLine.end.copy(tri.a);
        if (localPlane.intersectLine(tempLine, tempVector)) {
          // vectors.push(tempVector.clone());
          points.push(convertTo2dPointFromApp(tempVector, app));
        }

        if (points.length === 2) {
          let segment = {
            p1: points[0],
            p2: points[1],
          };
          segments.push(segment);

          // if (app.index == 0 && app.inversePointMatrix) {
          //   const vectors2 = [];
          //   for (const vector of vectors) {
          //     vectors2.push(
          //       vector.clone().applyMatrix4(app.inversePointMatrix)
          //     );
          //   }
          //   console.log("vectors", vectors, vectors2);
          // }
          // drawLine(vectors[0], vectors[1], color);
          // drawPoint(vectors[0], color, false, 0.05);
          // drawPoint(vectors[1], color, false, 0.05);
        }
      },
    });

    // const delta = window.performance.now() - startTime;
    // console.log(`slice time: ${parseFloat(delta.toFixed(3))}ms`);
  }
  return segments;
}

function getVerticesFromSegments(segments) {
  // console.log(segments);
  let vertices = [];
  let head = segments.length ? segments[0] : null;
  let tail = head;
  let headIndex = 0;
  let tailIndex = headIndex;
  while (head || tail) {
    if (head && headIndex >= 0) {
      vertices.unshift(head.p1);
      segments.splice(headIndex, 1);
    }
    if (tail && tailIndex >= 0) {
      vertices.push(tail.p2);
      if (head != tail) {
        segments.splice(
          !head || headIndex > tailIndex ? tailIndex : tailIndex - 1,
          1,
        );
      }
    }

    if (head) {
      headIndex = findHeadIndex(segments, head);
      head = headIndex >= 0 ? segments[headIndex] : null;
    }
    if (tail) {
      tailIndex = findTailIndex(segments, tail);
      tail = tailIndex >= 0 ? segments[tailIndex] : null;
    }
  }
  // console.log("segments.length", segments.length);
  return vertices;
}

function getFiguresFromVertices(verticesArr, model) {
  let figures = [];
  if (verticesArr && verticesArr.length) {
    verticesArr = verticesArr.sort((a, b) => b.length - a.length);
    let figure = null;
    verticesArr.forEach((vertices, index) => {
      let p1 = vertices[0];
      let p2 = vertices[vertices.length - 1];
      let distance = getDistance(p1, p2);
      if (
        figure &&
        !model.isTooth &&
        !model.isGingiva &&
        distance > 1 &&
        index === 1
      ) {
        let fp1 = figure.vertices[0];
        let fp2 = figure.vertices[figure.vertices.length - 1];
        let fdistance = getDistance(fp1, fp2);
        if (fdistance > 1) {
          let d1 = getDistance(p1, fp2);
          let d2 = getDistance(p2, fp2);
          figure.vertices =
            d1 < d2
              ? figure.vertices.concat(vertices)
              : figure.vertices.concat(vertices.toReversed());
          figure = null;
          return;
        }
      }
      figure = { vertices: vertices, filename: model.filename };
      figures.push(figure);
    });
  }
  return figures;
}

function getFigurePerimeter(figure) {
  let perimeter = 0;
  if (figure && figure.vertices && figure.vertices.length) {
    const vertices = figure.vertices;
    const length = vertices.length;
    for (let i = 0; i < length - 1; i++) {
      const p1 = vertices[i];
      const p2 = vertices[i + 1];
      const distance = getDistance(p1, p2);
      p1.distance = distance;
      perimeter += distance;
    }
    const lastDistance = getDistance(vertices[length - 1], vertices[0]);
    vertices[length - 1].distance = lastDistance;
    perimeter += lastDistance;
  }
  return perimeter;
}

function convertTo2dPoint(vector, appIndex) {
  let point = {
    x: appIndex == 1 ? vector.z : vector.x,
    y: appIndex == 0 ? vector.z : vector.y,
  };
  point.x = +point.x.toFixed(3);
  point.y = +point.y.toFixed(3);
  return point;
}

function convertTo2dPointFromApp(vector, app) {
  if (app.inverseImageOrientation) {
    vector = vector.applyMatrix4(app.inverseImageOrientation);
  }

  if (app.inversePointMatrix) {
    vector = vector.applyMatrix4(app.inversePointMatrix);
  }
  let point = {
    x: app.index == 1 ? vector.z : vector.x,
    y: app.index == 0 ? vector.z : vector.y,
  };
  point.x = +point.x.toFixed(3);
  point.y = +point.y.toFixed(3);
  return point;
}

function getDistance(p1, p2) {
  var dx = p1.x - p2.x;
  var dy = p1.y - p2.y;
  return Math.sqrt(dx * dx + dy * dy);
}

function findHeadIndex(segments, head) {
  let headIndex = segments.findIndex(
    (segment) => segment.p2.x == head.p1.x && segment.p2.y == head.p1.y,
  );
  if (headIndex < 0) {
    headIndex = segments.findIndex(
      (segment) => segment.p1.x == head.p1.x && segment.p1.y == head.p1.y,
    );
    let nhead = headIndex >= 0 ? segments[headIndex] : null;
    if (nhead) {
      let temp = nhead.p1;
      nhead.p1 = nhead.p2;
      nhead.p2 = temp;
    }
  }

  // if (headIndex < 0) {
  //   headIndex = segments.findIndex(
  //     (segment) => getDistance(segment.p2, head.p1) < 1
  //   );
  //   if (headIndex < 0) {
  //     headIndex = segments.findIndex(
  //       (segment) => getDistance(segment.p1, head.p1) < 1
  //     );
  //     let nhead = headIndex >= 0 ? segments[headIndex] : null;
  //     if (nhead) {
  //       let temp = nhead.p1;
  //       nhead.p1 = nhead.p2;
  //       nhead.p2 = temp;
  //     }
  //   }
  // }

  return headIndex;
}

function findTailIndex(segments, tail) {
  let tailIndex = segments.findIndex(
    (segment) => segment.p1.x == tail.p2.x && segment.p1.y == tail.p2.y,
  );
  if (tailIndex < 0) {
    tailIndex = segments.findIndex(
      (segment) => segment.p2.x == tail.p2.x && segment.p2.y == tail.p2.y,
    );
    let ntail = tailIndex >= 0 ? segments[tailIndex] : null;
    if (ntail) {
      let temp = ntail.p1;
      ntail.p1 = ntail.p2;
      ntail.p2 = temp;
    }
  }

  // if (tailIndex < 0) {
  //   tailIndex = segments.findIndex(
  //     (segment) => getDistance(segment.p1, tail.p2) < 1
  //   );
  //   if (tailIndex < 0) {
  //     tailIndex = segments.findIndex(
  //       (segment) => getDistance(segment.p2, tail.p2) < 1
  //     );
  //     let ntail = tailIndex >= 0 ? segments[tailIndex] : null;
  //     if (ntail) {
  //       let temp = ntail.p1;
  //       ntail.p1 = ntail.p2;
  //       ntail.p2 = temp;
  //     }
  //   }
  // }

  return tailIndex;
}

export {
  drawOutlines,
  destroyOutlines,
  highlightOutlines,
  convertTo2dPoint,
  getDistance,
  getFiguresForModel,
  getDrawBox2D,
  setupClippingPlane,
  getAllFiguresForModel,
  getFigurePerimeter,
  switchOutlineListening,
  drawOn2DCanvas,
  getActualColor,
};
